import { ViewAbsencePage } from "@features/rh/conges/components/ViewAbsencePage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/rh/conges/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.CONGES.VIEW),
  staticData: {
    title: "Voir une demande de congé",
    icon: Eye,
    permission: PERMISSIONS.RH.CONGES.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: ViewAbsencePage,
});
